import { getMPowerDiscounts, updateMPowerDiscount, createMPowerDiscount } from '../../../api/suppliers';
import {
  GET_ALL_MPOWER_DISCOUNTS,
  UPDATE_MPOWER_DISCOUNT,
  UPDATE_MPOWER_DISCOUNT_PENDING,
  CREATE_MPOWER_DISCOUNT,
  SUCCESS_MPOWER_UPDATED,
  SUCCESS_CREATED,
  BAD_MPOWER_LOAD,
  BAD_MPOWER_UPDATE,
  BAD_MPOWER_CREATE
} from '../constants';
export default {
  async updateDiscountPending({ commit, state }, value) {
    commit(UPDATE_MPOWER_DISCOUNT_PENDING, value);
  },
  async getAllDiscounts({ commit, state }, payload) {
    try {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, true);
      const data = await getMPowerDiscounts(payload.supplier._id);
      commit(GET_ALL_MPOWER_DISCOUNTS, data);
    } catch (e) {
      commit(BAD_MPOWER_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, false);
    }
  },
  async updateDiscount({ commit, state }, payload) {
    try {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, true);
      const data = await updateMPowerDiscount(payload.supplier._id, payload.discount);
      commit(UPDATE_MPOWER_DISCOUNT, data);
      commit(SUCCESS_MPOWER_UPDATED, null, { root: true });
    } catch (e) {
      commit(BAD_MPOWER_UPDATE, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, false);
    }
  },
  async createDiscount({ commit, state }, payload) {
    try {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, true);
      const data = await createMPowerDiscount(payload.supplier._id, payload.discount);
      commit(CREATE_MPOWER_DISCOUNT, data);
      commit(SUCCESS_CREATED, '', { root: true });
    } catch (e) {
      commit(BAD_MPOWER_CREATE, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(UPDATE_MPOWER_DISCOUNT_PENDING, false);
    }
  }
};
